module.exports = __webpack_public_path__ + "img/PL08149.6a455d86.png";